<template>
  <div class="footer-box">
    <div
      v-for="(item, index) in footerData"
      :key="index"
      class="footer-cell"
      :class="{ 'no-border': index === footerData.length - 1 }"
    >{{ $t('common.' + item.label) }}</div>
    <div class="footer-cell no-border" style="margin-left: 15px;">{{ $t('common.company') }}</div>
  </div>
</template>

<script>
import { footerData } from '@/assets/config/index.js'
export default {
  computed: {
    footerData() {
      return footerData
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-box {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  color: #999;
  background-color: #000;
  font-size: 12px;
}
.footer-cell {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 12px;
  padding: 0 5px;
  border-right: 1px solid #999;
  &.no-border {
    border-right: none;
  }
}
</style>
